// extracted by mini-css-extract-plugin
export default {"productGallery":"mH-z","inQuickShop":"nH-z"};